jQuery(function ($) {
  const sections = $('[data-download]');

  $.each(sections, function () {
    const section = $(this);
    const file = section.data('download');
    const trigger = section.find('[data-download-trigger]');

    if (file.length) {
      const prompt = setTimeout(function () {
        window.location = file;
      }, 3000);

      trigger.on('click', function () {
        window.location = file;
        clearTimeout(prompt);
      });
    }
  });
});
